//import { Route, Router, history } from 'react-router';
import { Route, Router, BrowserRouter, HashRouter, Switch } from "react-router-dom";

import "./TeamRiverRunner.css";
import React, { Component } from "react";
import ProtectedRoute from "./components/ProtectedRoute";
import Event from "./components/event/Event";
import EventDemo from "./components/event/EventDemo";
import Events from "./components/Events";
import Chapter from "./components/chapter/Chapter";
import SideBarLayout from "./components/SideBarLayout";
import SimpleLayout from "./components/SimpleLayout";
import EventsSideBar from "./components/EventsSideBar";
import Calendar from "./components/Calendar";
import NavMenu from "./components/NavMenu";
import ComingSoon from "./components/ComingSoon";
import { createStore } from "./components/store";
import SignIn from "./components/account/SignIn";
import SignUp from "./components/account/SignUp";

import CalendarSideBar from "./components/CalendarSideBar";
import Chapters from "./components/Chapters";
import Members from "./components/Members";
import Member from "./components/member/Member";
import MembersSideBar from "./components/MembersSideBar";
import TestPage from "./components/TestPage";
import DynamicDemographics from "./components/reports/DemographicReports";
import MembersReport from "./components/reports/MembersReport";
import EventsByType from "./components/reports/EventsByType";
import VeteransBySite from "./components/reports/VeteransBySite";
import VeteransAttendence from "./components/reports/VeteransAttendence";
import MembersAttendance from "./components/reports/MembersAttendance";
import ReportsList from "./components/reports/ReportsList";
import PasswordReset from "./components/account/PasswordReset";
import VeteransByEventType from "./components/reports/VeteransByEventType";
import Region from "./components/chapter/Region";
import GoldenPaddle from "./components/reports/GoldenPaddle";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.datefrom = new Date();
    this.datefrom.setDate(1);
    this.dateto = new Date();
    this.dateto.setMonth(this.dateto.getMonth() + 1);
    this.dateto.setDate(1);
    this.state = {
      chapterFilter: [],
      eventFilter: {
        title: [],
        dateFrom: this.datefrom,
        dateTo: this.dateto,
        timeFrom: { activated: false, hours: 8, minutes: 0, am: true },
        timeTo: { activated: false, hours: 8, minutes: 0, am: true },
        typeOfEvent: "",
        status: "",
        color: "",
        chapter: [],
      },
      memberFilter: {
        name: [],
        role: 0,
        dateFrom: null,
        dateTo: null,
        zip: "",
        active: true,
        chapter: [],
      },
    };
  }

  render() {
      var isLoggedIn = this.props.store.userInfo != null;
      console.log(this.props.store, this.props.store.userInfo, isLoggedIn);
      return (
          <HashRouter>
        <Switch>
          <Route
            exact
            path="/"
            render={(match) => (
              <div>
                <NavMenu {...match} />
                <SideBarLayout
                  {...match}
                  sideBarContent={CalendarSideBar}
                  bodyContent={Calendar}
                  onSideBarDropDownValueChange={(value) => {
                    this.setState({ chapterFilter: value });
                  }}
                  onBodyDropDownValueChange={(value) =>
                    this.setState({ chapterFilter: value })
                  }
                  chapterFilter={this.state.chapterFilter}
                  clearChapterFilter={() =>
                    this.setState({ chapterFilter: [] })
                  }
                />
              </div>
            )}
          />
          <Route
            path="/events"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SideBarLayout
                    {...match}
                    sideBarContent={EventsSideBar}
                    bodyContent={Events}
                    onEventChange={(value) => {
                      this.setState({ eventFilter: value });
                    }}
                    eventFilter={this.state.eventFilter}
                    clearEventFilter={() =>
                      this.setState({
                        eventFilter: {
                          title: [],
                          dateFrom: this.datefrom,
                          dateTo: this.dateto,
                          timeFrom: {
                            activated: false,
                            hours: 8,
                            minutes: 0,
                            am: true,
                          },
                          timeTo: {
                            activated: false,
                            hours: 8,
                            minutes: 0,
                            am: true,
                          },
                          typeOfEvent: "",
                          status: "",
                          color: "",
                          chapter: [],
                        },
                      })
                    }
                  />
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/members"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SideBarLayout
                    {...match}
                    sideBarContent={MembersSideBar}
                    bodyContent={Members}
                    onMemberChange={(value) => {
                      this.setState({ memberFilter: value });
                    }}
                    memberFilter={this.state.memberFilter}
                    clearMemberFilter={() =>
                      this.setState({
                        memberFilter: {
                          name: [],
                          role: 0,
                          dateFrom: null,
                          dateTo: null,
                          zip: "",
                          active: true,
                          chapter: [],
                        },
                      })
                    }
                  />
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/event-edit/:id"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Event {...match} newEvent={false} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/new-event"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Event {...match} newEvent={true} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/chapters"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Chapters {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/region/:id"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Region {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/new-region"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Region {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/new-member"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Member {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/profile"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Member {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/member/:id"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Member {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/SignIn"
            render={(match) => (
              <div>
                <SimpleLayout>
                  <SignIn {...match} />
                </SimpleLayout>
              </div>
            )}
          />
          <Route
            path="/SignUp"
            render={(match) => (
              <div>
                <SimpleLayout>
                  <SignUp {...match} />
                </SimpleLayout>
              </div>
            )}
          />
          <Route
            path="/ForgotPassword"
            render={(match) => (
              <div>
                <SimpleLayout>
                  <PasswordReset {...match} />
                </SimpleLayout>
              </div>
            )}
          />
          <Route
            path="/PasswordReset/:token"
            render={(match) => (
              <div>
                <SimpleLayout>
                  <PasswordReset {...match} />
                </SimpleLayout>
              </div>
            )}
          />

          <Route
            path="/reports"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <ReportsList {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/event-view/:id"
            render={(match) => (
              <div>
                <NavMenu {...match} />
                <SimpleLayout>
                  <EventDemo {...match} />
                </SimpleLayout>
              </div>
            )}
          />
          <Route
            path="/new-chapter"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Chapter {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/edit-chapter/:id"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <Chapter {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />

          <Route
            path="/Report/DynamicDemographics"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <DynamicDemographics {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />

          <Route
            path="/Report/Members"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <MembersReport {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/Report/EventsByType"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <EventsByType {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/Report/VeteransBySite"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <VeteransBySite {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/Report/VeteransAttendence"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <VeteransAttendence {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
                  <Route
                      path="/Report/MembersAttendance"
                      render={(match) => (
                          <ProtectedRoute isLoggedIn={isLoggedIn}>
                              <div>
                                  <NavMenu {...match} />
                                  <SimpleLayout>
                                      <MembersAttendance {...match} />
                                  </SimpleLayout>
                              </div>
                          </ProtectedRoute>
                      )}
                  />
          <Route
            path="/Report/VeteransByEventType"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <VeteransByEventType {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route
            path="/Report/GoldenPaddle"
            render={(match) => (
              <ProtectedRoute isLoggedIn={isLoggedIn}>
                <div>
                  <NavMenu {...match} />
                  <SimpleLayout>
                    <GoldenPaddle {...match} />
                  </SimpleLayout>
                </div>
              </ProtectedRoute>
            )}
          />
          <Route path="/test" component={TestPage} />
        </Switch>
          </HashRouter>
    );
  }
}

export default createStore(App);



// WEBPACK FOOTER //
// ./src/App.js